import { notification } from "antd";

import {
  AuthorizedFormApiService,
  AuthorizedApiService,
} from "../../../services/apiServices";
import { GET_AFIPS, UPLOAD_AFIP } from "./types";

export const afipUpload = (data) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("json", data);
    dispatch({
      type: UPLOAD_AFIP,
      payload: true,
    });
    AuthorizedFormApiService.post("afip", formData)
      .then((res) => {
        const { status } = res;
        if (status !== 201) {
          notification.error({
            message: "Something went wrong",
          });
          dispatch({
            type: UPLOAD_AFIP,
            payload: false,
          });
          return;
        }
        notification.success({
          message: "AFIP file created",
        });
        dispatch(getAfips());
        dispatch({
          type: UPLOAD_AFIP,
          payload: false,
        });
      })
      .catch(() => {
        notification.error({
          message: "Something went wrong",
        });
        dispatch({
          type: UPLOAD_AFIP,
          payload: false,
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
    dispatch({
      type: UPLOAD_AFIP,
      payload: false,
    });
  }
};

export const afipDelete = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPLOAD_AFIP,
      payload: true,
    });
    AuthorizedApiService.delete(`afip/${id}`)
      .then((res) => {
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          dispatch({
            type: UPLOAD_AFIP,
            payload: false,
          });
          return;
        }
        notification.success({
          message: "AFIP file deleted",
        });
        dispatch({
          type: UPLOAD_AFIP,
          payload: false,
        });
        dispatch(getAfips());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
        dispatch({
          type: UPLOAD_AFIP,
          payload: false,
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
    dispatch({
      type: UPLOAD_AFIP,
      payload: false,
    });
  }
};

export const getAfips = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("afip")
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong,can not get AFIPs",
          });
          return;
        }

        dispatch({
          type: GET_AFIPS,
          payload: data,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (error) {
    notification.error({
      message: "Something went wrong",
    });
  }
};
